import { render, staticRenderFns } from "./SelectUniversityInput.vue?vue&type=template&id=87e6c8f4&scoped=true"
import script from "./SelectUniversityInput.vue?vue&type=script&lang=ts"
export * from "./SelectUniversityInput.vue?vue&type=script&lang=ts"
import style0 from "./SelectUniversityInput.vue?vue&type=style&index=0&id=87e6c8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e6c8f4",
  null
  
)

export default component.exports